
import rules from "@/services/helpers/validation-rules";
import Vue from "vue";
import DatePicker from "../../../components/form-components/DatePicker.vue";
import PhonePicker from "@/components/form-components/PhonePicker.vue";

export default Vue.extend({
  name: "Civil",

  components: {
    DatePicker,
    PhonePicker,
  },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    errorMessages: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data: () => ({
    rules,
    model: {} as any,
    menu: false,
  }),

  watch: {
    menu(val) {
      setTimeout(() => {
        if (val && this.$refs.picker) {
          (this.$refs.picker as any).activePicker = "YEAR";
        }
      });
    },
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.model = this.value;
      },
    },
    "model.abiturient.is_married"() {
      if (!this.model.abiturient.is_married) {
        // delete
      }
    },
  },

  computed: {
    maxPartner() {
      return this.$moment().format("YYYY-MM-DD");
    },
    minKids() {
      return this.$moment().subtract(18, "years").format("YYYY-MM-DD");
    },
    maxKids() {
      return this.$moment().format("YYYY-MM-DD");
    },
    civilStatuses() {
      return [
        {
          text: this.$t(
            "applications.form.family_members.civil_status.is_married"
          ),
          value: true,
        },
        {
          text: this.$t(
            "applications.form.family_members.civil_status.no_married"
          ),
          value: false,
        },
      ];
    },
  },

  methods: {
    add(): void {
      if (!this.model.family_members.children) {
        this.model.family_members.children = [];
      }
      this.model.family_members.children.push({ role: "child" });
    },
    remove(index: number): void {
      this.model.family_members.children.splice(index, 1);
    },
    submit() {
      this.$emit("submit");
    },
    save(date: string) {
      (this.$refs.menu as any).save(date);
    },
  },
});
